module.exports = __webpack_public_path__ + "media/images/icon__close-ea6fbf11b64107f4a335567883f5b1c0.png";